import {
  SEARCH_PARTICIPANTS_REQUEST,
  SEARCH_PARTICIPANTS_SUCCESS,
  SEARCH_PARTICIPANTS_FAILURE,
  CLEAR_SEARCH_DATA,
  statusType
} from '../../actions'

const initial = {
  data: [],
  status: statusType.IDLE
}

const activityParticipants = (state = initial, action) => {
  switch (action.type) {
    case SEARCH_PARTICIPANTS_REQUEST:
      return {
        ...initial,
        status: statusType.IN_PROGRESS
      }

    case SEARCH_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: statusType.SUCCESS
      }

    case SEARCH_PARTICIPANTS_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case CLEAR_SEARCH_DATA:
      return { ...initial }

    default:
      return state
  }
}

export default activityParticipants
